import TabBar from '@alltrails/shared/denali/components/TabBar';
import { Context } from '@alltrails/shared/types/context';
import logStatsViewed from '@alltrails/analytics/events/logStatsViewed';
import logReviewsViewed from '@alltrails/analytics/events/logReviewsViewed';
import logPhotosViewed from '@alltrails/analytics/events/logPhotosViewed';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

import * as styles from './styles/styles.module.scss';

type Tab = {
  id: string;
  label: string;
  linkPath: string;
  isActive: boolean;
  openInNewWindow: boolean;
};

type LinkInfo = {
  href: string;
  target: '_blank' | '_self' | '_parent' | '_top';
};

type TabLink = {
  id: string;
  label: string;
  testId: string;
  linkInfo: LinkInfo;
};

type Props = {
  tabs: Tab[];
  context: Context;
  userId: string | number;
};

const ProfileSlidingTabs = ({ tabs, context, userId }: Props) => {
  const tabLinks: TabLink[] = tabs.map(({ label, linkPath, openInNewWindow }) => {
    const href = LanguageSupportUtil.wrapUrlSafe(linkPath, context?.languageRegionCode);
    const target = openInNewWindow ? '_blank' : null;
    return {
      id: label,
      label,
      testId: `profile-tab-${label}`,
      linkInfo: { href, target }
    };
  });

  const logAmplitudeEvents = (label: string) => {
    const isOwnedByUser = context.currentUser?.id === userId;
    const amplitudeEventObject = { owned_by_user: isOwnedByUser, owner_id: userId as string };
    switch (label) {
      case 'Stats':
        return logStatsViewed(amplitudeEventObject);
      case 'Reviews':
        return logReviewsViewed(amplitudeEventObject);
      case 'Photos':
        return logPhotosViewed(amplitudeEventObject);
      default:
        return '';
    }
  };

  return (
    <div className={styles.profileSlidingTabsContainer}>
      <TabBar
        activeTab={tabs.find(tab => tab.isActive).label}
        className={styles.tabBar}
        hideBottomBorder
        onChange={(label: string) => {
          logAmplitudeEvents(label);
        }}
        tabs={tabLinks}
        testId="profile-tab-bar"
      />
    </div>
  );
};

export default ProfileSlidingTabs;
